import type { FC, PropsWithChildren } from 'react'
import styled from '@emotion/styled'

import Typography from '@segment/matcha/components/Typography'

import CategoryHeaderBase, * as CategoryHeader from '@segment/matcha/recipes/CategoryHeader'
import CardsGrid from '@segment/matcha/recipes/CardsGrid'

import type { FetchedCatalogIntegration } from '@segment/api/routes/catalog/queries'

import type { Hit } from '@segment/api/algolia/client'

import CatalogGridBase, * as CatalogGrid from '../CatalogGrid'
import IntegrationCardTemplate from '../../../components/IntegrationCard'

interface GroupedGridProps {
  category?: { name: string; slug: string }
  nextPageTrigger: JSX.Element
  flattenedPages?: Hit<FetchedCatalogIntegration>[]
  isEmpty?: boolean
  isLoading?: boolean
}

const CategoryGrid: FC<PropsWithChildren<GroupedGridProps>> = ({
  category,
  nextPageTrigger,
  flattenedPages,
  isEmpty,
  isLoading,
}) => {
  if (!category) {
    return null
  }

  return (
    <CatalogGridBase>
      <CatalogGrid.Group aria-live="polite" aria-busy={isLoading}>
        <CategoryHeaderBase>
          <CategoryHeader.Title variant="h4">{category.name}</CategoryHeader.Title>
        </CategoryHeaderBase>

        <CardsGrid limitItems={false}>
          {flattenedPages?.map((integration) => (
            <IntegrationCardTemplate key={integration.objectID} integration={integration} isInCategoryGrid={true} />
          ))}
        </CardsGrid>

        {isEmpty && (
          <NoMarginTypography variant="pMedium">
            Sorry, we couldn’t find anything that fit your search.
          </NoMarginTypography>
        )}
        {nextPageTrigger}
      </CatalogGrid.Group>
    </CatalogGridBase>
  )
}

export default CategoryGrid

const NoMarginTypography = styled(Typography)`
  margin: 0;
`
